// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import './Tab.scss';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { mergeClasses } from 'util/commons';

interface Props {
  className?: string;
  tabMenuClassName?: string;
  tabItems: React.ReactNode[];
  defaultTabIndex: number;
  renderContent: (item: {
    index: number;
    tab: React.ReactNode;
  }) => React.ReactNode;
  setTabIndex?: (tabIndex: number) => void;
  withHash?: boolean;
}

const validHash = ['#0', '#1', '#2'];

export const Tab = ({
  className,
  tabMenuClassName,
  tabItems,
  defaultTabIndex,
  renderContent,
  setTabIndex,
  withHash = true,
}: Props) => {
  const [activedTabIndex, setActivedTabIndex] = useState(
    defaultTabIndex ? defaultTabIndex : 0
  );
  useEffect(() => {
    if (setTabIndex) {
      setTabIndex(activedTabIndex);
    }
  }, [activedTabIndex]);

  useEffect(() => {
    setActivedTabIndex(defaultTabIndex ? defaultTabIndex : 0);
  }, [defaultTabIndex]);

  const history = useHistory();

  useEffect(() => {
    if (!withHash) {
      return;
    }

    if (!validHash.includes(history.location.hash)) {
      setActivedTabIndex(0);
      location.replace('#0');
    }
  }, [history.location.hash, withHash]);

  return (
    <div className={className}>
      <div className={mergeClasses('tab-menu', tabMenuClassName)}>
        <div className="tab-items">
          {tabItems.map((it, index) => {
            const actived = index === activedTabIndex;
            return (
              <div
                key={index}
                className={'tab-item ' + (actived ? 'active' : '')}
                onClick={() => {
                  setActivedTabIndex(index);
                  if (withHash) {
                    history.push(`${window.location.search}#` + index);
                  }
                }}
              >
                {it}
              </div>
            );
          })}
        </div>
      </div>
      <div className="tab-container">
        {tabItems.map((tab, index) => (
          <div
            key={`tab-content-${index}`}
            className={index !== activedTabIndex ? 'hidden' : ''}
          >
            {renderContent({ index, tab })}
          </div>
        ))}
      </div>
    </div>
  );
};
